import { mainSiteUrl } from '@/mocks/categories';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeatureCards from './components/FeatureCards';
import CategoryGrid from './components/CategoryGrid';
import ArticleCards from './components/ArticleCards';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://basetaosheet.store';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      {/* WebSite Schema.org JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'BaseTao Spreadsheet Hub',
            url: siteUrl,
            description: 'The ultimate BaseTao Spreadsheet resource covering reviews, shipping costs, warehouse guides, discount codes, comparisons and expert tips.',
            potentialAction: {
              '@type': 'SearchAction',
              target: `${siteUrl}/search?q={search_term_string}`,
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />

      {/* Organization Schema.org JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'BaseTao Spreadsheet Hub',
            url: siteUrl,
            logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/0dc5bc4081b05862da3d01553c9c9d93.png',
            description: 'The most complete BaseTao Spreadsheet research platform covering reviews, shipping costs, warehouse guides, discount codes, comparisons, and expert tips.',
            sameAs: [
              'https://kaspreadsheet.com',
            ],
          }),
        }}
      />

      <Navbar />
      <Hero />

      {/* Feature Cards Section */}
      <FeatureCards />

      {/* Main CTA Banner - unique image */}
      <section className="relative py-14 md:py-16 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=Stylish%20shopping%20mall%20interior%20with%20elegant%20boutique%20displays%20and%20fashion%20mannequins%2C%20warm%20ambient%20spotlighting%2C%20cream%20and%20gold%20color%20palette%2C%20luxury%20retail%20atmosphere%2C%20editorial%20interior%20photography%20style%2C%20clean%20modern%20aesthetic%2C%20premium%20shopping%20experience%2C%20soft%20warm%20tones&width=1800&height=600&seq=cta-banner-unique&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
            aria-hidden="true"
          />
        </div>
        <div className="absolute inset-0 bg-black/40 z-[1]"></div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
            Ready to Level Up Your Shopping Game?
          </h2>
          <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-xl mx-auto">
            Explore thousands of products across all categories on our main website. BaseTao Spreadsheet gives you the research power &mdash; now it is time to shop.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              BaseTao Spreadsheet
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50 text-foreground-900 font-semibold text-sm rounded-full hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer border border-background-200"
            >
              Buy It Now
            </a>
          </div>
        </div>
      </section>

      {/* Category Grid */}
      <CategoryGrid />

      {/* Article Cards */}
      <ArticleCards />

      {/* FAQ */}
      <FAQ />

      {/* Footer */}
      <Footer />
    </main>
  );
}